import { gql } from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  FieldSet: { input: any; output: any; }
  JSONString: { input: any; output: any; }
  /** StringOrInt scalar type that can represent either a string or number value. */
  StringOrInt: { input: any; output: any; }
  Time: { input: any; output: any; }
  _Any: { input: any; output: any; }
  federation__Policy: { input: any; output: any; }
  federation__Scope: { input: any; output: any; }
};

export type AssociatedSchedule = {
  __typename?: 'AssociatedSchedule';
  id: Scalars['ID']['output'];
};

export type CalendarEntry = {
  __typename?: 'CalendarEntry';
  calendarType: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  monthName: Scalars['String']['output'];
  quarter: Scalars['Int']['output'];
  quarterName: Scalars['String']['output'];
  week: Scalars['Int']['output'];
  weekEndDate: Scalars['String']['output'];
  weekStartDate: Scalars['String']['output'];
  year: Scalars['Int']['output'];
  yearName: Scalars['String']['output'];
};

export enum CalendarType {
  Broadcast = 'BROADCAST',
  Standard = 'STANDARD'
}

export type Country = {
  __typename?: 'Country';
  code?: Maybe<Scalars['String']['output']>;
  continent?: Maybe<Scalars['String']['output']>;
  division?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  resourceSet?: Maybe<ResourceSet>;
};

export type Creative = {
  __typename?: 'Creative';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type CurrencyOptionCriteria = {
  __typename?: 'CurrencyOptionCriteria';
  currencyID: Scalars['ID']['output'];
  sourceID: Scalars['ID']['output'];
};

export type CurrencyOptionCriteriaInput = {
  currencyID: Scalars['ID']['input'];
  sourceID: Scalars['ID']['input'];
};

/** CurrencySource is an individual currency source, independent of currency. */
export type CurrencySource = {
  __typename?: 'CurrencySource';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CustomDimension = {
  __typename?: 'CustomDimension';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**
 * CustomFilter defines the properties for a custom filter.  If it is a
 * lookup-type filter, it contains additional information about the lookup.
 * Note: isLookup and lookup fields apply to string typed filter only. The expected
 * dataTypes are TEXT and TIMESTAMP_NTZ
 */
export type CustomFilter = {
  __typename?: 'CustomFilter';
  dataType: FieldDataTypeEnum;
  id: Scalars['ID']['output'];
  isLookup: Scalars['Boolean']['output'];
  lookup?: Maybe<Lookup>;
  name: Scalars['String']['output'];
};

export type CustomFilterCriteria = {
  __typename?: 'CustomFilterCriteria';
  dateFilters?: Maybe<Array<DateCustomFilterCriteria>>;
  lookupFilters?: Maybe<Array<LookupCustomFilterCriteria>>;
  stringFilters?: Maybe<Array<StringCustomFilterCriteria>>;
};

/** Combination of various custom filters to be supported */
export type CustomFilterCriteriaInput = {
  lookupFilters?: InputMaybe<Array<LookupCustomFilterCriteriaInput>>;
  stringFilters?: InputMaybe<Array<StringCustomFilterCriteriaInput>>;
};

export type CustomMetadata = {
  __typename?: 'CustomMetadata';
  dataType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** DailySchedule */
export type DailySchedule = {
  __typename?: 'DailySchedule';
  /** recurrence interval in days */
  recurrence: Scalars['Int']['output'];
};

/** DailyScheduleInput */
export type DailyScheduleInput = {
  /** recurrence interval in days */
  recurrence: Scalars['Int']['input'];
};

/** Custom filter type supporting date comparison */
export type DateCustomFilterCriteria = {
  __typename?: 'DateCustomFilterCriteria';
  id: Scalars['ID']['output'];
  range: PeriodRange;
};

export type Demo = {
  __typename?: 'Demo';
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  resourceSet?: Maybe<ResourceSet>;
};

export type DimensionCriteria = {
  __typename?: 'DimensionCriteria';
  dimensionIDs?: Maybe<Array<Scalars['ID']['output']>>;
};

export type DimensionCriteriaInput = {
  dimensionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DimensionGrouping = {
  __typename?: 'DimensionGrouping';
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**
 * EmailDelivery defines information needed to deliver a report by email
 * TODO: Email validation
 */
export type EmailDelivery = {
  __typename?: 'EmailDelivery';
  emails: Array<Scalars['String']['output']>;
};

/**
 * EmailDeliveryInput defines information needed to deliver a report by email
 * TODO: Email validation
 */
export type EmailDeliveryInput = {
  emails: Array<Scalars['String']['input']>;
};

/** FTPDelivery defines information needed to deliver a report by FTP */
export type FtpDelivery = {
  __typename?: 'FTPDelivery';
  filePath?: Maybe<Scalars['String']['output']>;
  ftps?: Maybe<FtpsConfig>;
  protocol: FileTransferProtocolEnum;
  sftp?: Maybe<SftpConfig>;
};

/** FTPDeliveryInput defines information needed to deliver a report by FTP */
export type FtpDeliveryInput = {
  filePath?: InputMaybe<Scalars['String']['input']>;
  ftps?: InputMaybe<FtpsConfigInput>;
  protocol: FileTransferProtocolEnum;
  sftp?: InputMaybe<SftpConfigInput>;
};

/** FTPSConfig defines information needed to deliver a report by FTPS */
export type FtpsConfig = {
  __typename?: 'FTPSConfig';
  host: Scalars['String']['output'];
  password: Scalars['String']['output'];
  port: Scalars['Int']['output'];
  useExplicit: Scalars['Boolean']['output'];
  user: Scalars['String']['output'];
};

/** FTPSConfigInput defines information needed to deliver a report by FTPS */
export type FtpsConfigInput = {
  host: Scalars['String']['input'];
  password: Scalars['String']['input'];
  port: Scalars['Int']['input'];
  useExplicit: Scalars['Boolean']['input'];
  user: Scalars['String']['input'];
};

/**
 * FieldDataTypeEnum is the set of valid data types used in the FIELD_MAP table.
 * Note these are Snowflake data types.
 */
export enum FieldDataTypeEnum {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Float = 'FLOAT',
  Number = 'NUMBER',
  Text = 'TEXT',
  TimestampNtz = 'TIMESTAMP_NTZ'
}

/** FileTransferProtocolEnum is the set of supported file upload protocols. */
export enum FileTransferProtocolEnum {
  Ftps = 'FTPS',
  Sftp = 'SFTP'
}

export type FilterCriteria = {
  __typename?: 'FilterCriteria';
  custom?: Maybe<CustomFilterCriteria>;
  standard?: Maybe<StandardFilterCriteria>;
};

export type FilterCriteriaInput = {
  custom?: InputMaybe<CustomFilterCriteriaInput>;
  standard?: InputMaybe<StandardFilterCriteriaInput>;
};

/** Holds user folder information */
export type Folder = {
  __typename?: 'Folder';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Scalars['ID']['output']>;
  reports?: Maybe<Array<UserReport>>;
  schedules?: Maybe<Array<ReportScheduleSummary>>;
};

export type FundingSource = {
  __typename?: 'FundingSource';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
};

export type IdNamePair = {
  __typename?: 'IDNamePair';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Location = {
  __typename?: 'Location';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** Lookup defines the properties for a lookup-type custom field. */
export type Lookup = {
  __typename?: 'Lookup';
  defID: Scalars['ID']['output'];
  items: Array<LookupItem>;
  name: Scalars['String']['output'];
};

/** Custom filter type supporting lookup values comparison */
export type LookupCustomFilterCriteria = {
  __typename?: 'LookupCustomFilterCriteria';
  id: Scalars['ID']['output'];
  lookupItemIds: Array<Scalars['ID']['output']>;
};

/** Custom filter type supporting lookup values comparison */
export type LookupCustomFilterCriteriaInput = {
  id: Scalars['ID']['input'];
  lookupItemIds: Array<Scalars['ID']['input']>;
};

/** LookupItem is one of the possbile choices for a lookup-type custom field. */
export type LookupItem = {
  __typename?: 'LookupItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Contains the list of schedule ids that were successfully deleted
 * and a list of ids where the deletion failed.
 */
export type MtDeleteSchedulesResponse = {
  __typename?: 'MTDeleteSchedulesResponse';
  failureScheduleIds?: Maybe<Array<Scalars['Int']['output']>>;
  successScheduleIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type MtDimension = {
  __typename?: 'MTDimension';
  dataType?: Maybe<FieldDataTypeEnum>;
  group: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isStandard?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type MtDimensionData = {
  __typename?: 'MTDimensionData';
  dimension?: Maybe<MtDimension>;
  value?: Maybe<Scalars['StringOrInt']['output']>;
};

/**
 * Contains the list of schedule ids that were successfully deleted
 * and a list of ids where the deletion failed.
 */
export type MtDisableSchedulesResponse = {
  __typename?: 'MTDisableSchedulesResponse';
  failureScheduleIds?: Maybe<Array<Scalars['Int']['output']>>;
  successScheduleIds?: Maybe<Array<Scalars['Int']['output']>>;
};

/**
 * Contains the list of schedule ids that were successfully deleted
 * and a list of ids where the deletion failed.
 */
export type MtEnableSchedulesResponse = {
  __typename?: 'MTEnableSchedulesResponse';
  failureScheduleIds?: Maybe<Array<Scalars['Int']['output']>>;
  successScheduleIds?: Maybe<Array<Scalars['Int']['output']>>;
};

export type MtMeasure = {
  __typename?: 'MTMeasure';
  costRelated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isStandard?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  variationID?: Maybe<Scalars['String']['output']>;
  variationName?: Maybe<Scalars['String']['output']>;
};

export type MtMeasureData = {
  __typename?: 'MTMeasureData';
  measure?: Maybe<MtMeasure>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type MtReportDataWithParams = {
  __typename?: 'MTReportDataWithParams';
  data: MtReporterDataResponse;
  reportParams: MtReportParams;
};

export type MtReportParams = {
  __typename?: 'MTReportParams';
  criteria: MtReporterCriteria;
  settings: Scalars['JSONString']['output'];
};

export type MtReportSaveCriteriaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  reportCriteria: MtReporterCriteriaInput;
  reportSettings: Scalars['JSONString']['input'];
  reportTypeId: Scalars['ID']['input'];
  shared: Scalars['Boolean']['input'];
};

/** MTReportSchedule */
export type MtReportSchedule = {
  __typename?: 'MTReportSchedule';
  delivery: ReportDelivery;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  reportFormat: ReportFormat;
  reportId: Scalars['ID']['output'];
  scheduleDetail: Schedule;
};

/** MTReportScheduleSummary */
export type MtReportScheduleSummary = {
  __typename?: 'MTReportScheduleSummary';
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expireDateTime: Scalars['Time']['output'];
  fileFormat: ReportExportFormatEnum;
  folder?: Maybe<Folder>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  recurrencePattern: Scalars['String']['output'];
  source: Scalars['String']['output'];
  startDateTime: Scalars['Time']['output'];
  timezone: Scalars['String']['output'];
};

export type MtReporterCriteria = {
  __typename?: 'MTReporterCriteria';
  dimension: DimensionCriteria;
  filter: FilterCriteria;
  measure: Array<MeasureCriteria>;
  period: PeriodCriteria;
  productHierarchy?: Maybe<Scalars['ID']['output']>;
  resourceSet?: Maybe<Array<Scalars['ID']['output']>>;
  restrictedLabel?: Maybe<Scalars['String']['output']>;
};

export type MtReporterCriteriaInput = {
  dimension: DimensionCriteriaInput;
  filter: FilterCriteriaInput;
  measure: Array<MeasureCriteriaInput>;
  period: PeriodCriteriaInput;
  productHierarchy?: InputMaybe<Scalars['ID']['input']>;
  resourceSet?: InputMaybe<Array<Scalars['ID']['input']>>;
  restrictedLabel?: InputMaybe<Scalars['String']['input']>;
};

export type MtReporterDataItem = {
  __typename?: 'MTReporterDataItem';
  dimensions?: Maybe<Array<Maybe<MtDimensionData>>>;
  measures?: Maybe<Array<Maybe<MtMeasureData>>>;
  period?: Maybe<Period>;
};

export type MtReporterDataResponse = {
  __typename?: 'MTReporterDataResponse';
  dimensions?: Maybe<Array<Maybe<MtDimension>>>;
  measures?: Maybe<Array<Maybe<MtMeasure>>>;
  mtReporterData?: Maybe<Array<Maybe<MtReporterDataItem>>>;
  periodAggregation?: Maybe<PeriodAggregationEnum>;
};

export type MtUserReport = {
  __typename?: 'MTUserReport';
  associatedSchedules: Array<Maybe<AssociatedSchedule>>;
  created: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiresOn: Scalars['Int']['output'];
  folder?: Maybe<Folder>;
  id: Scalars['ID']['output'];
  lastModified: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  shared: Scalars['Boolean']['output'];
  typeId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type Market = {
  __typename?: 'Market';
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type Measure = {
  __typename?: 'Measure';
  costRelated: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type MeasureCriteria = {
  __typename?: 'MeasureCriteria';
  currencyOption?: Maybe<CurrencyOptionCriteria>;
  measureID: Scalars['ID']['output'];
  planTypeID?: Maybe<Scalars['ID']['output']>;
  snapshotID?: Maybe<Scalars['ID']['output']>;
  sourceTypeID?: Maybe<Scalars['ID']['output']>;
  variationID?: Maybe<Scalars['String']['output']>;
  variationName?: Maybe<Scalars['String']['output']>;
};

export type MeasureCriteriaInput = {
  currencyOption?: InputMaybe<CurrencyOptionCriteriaInput>;
  measureID: Scalars['ID']['input'];
  planTypeID?: InputMaybe<Scalars['ID']['input']>;
  snapshotID?: InputMaybe<Scalars['ID']['input']>;
  sourceTypeID?: InputMaybe<Scalars['ID']['input']>;
  variationID?: InputMaybe<Scalars['String']['input']>;
  variationName?: InputMaybe<Scalars['String']['input']>;
};

export type MediaType = {
  __typename?: 'MediaType';
  allowImpressionOverride: Scalars['Boolean']['output'];
  defaultCommission?: Maybe<Scalars['Float']['output']>;
  enableDailyCosts: Scalars['Boolean']['output'];
  enableExternalActuals: Scalars['Boolean']['output'];
  externalActualsNet: Scalars['Boolean']['output'];
  grpDecimals?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  localize: Scalars['Boolean']['output'];
  markets: Array<Maybe<Market>>;
  mediaClass?: Maybe<Scalars['String']['output']>;
  mediaGroup?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  resourceSet: ResourceSet;
  restrictInteractiveCosts: Scalars['Boolean']['output'];
  subtypes: Array<Maybe<Subtype>>;
  units: Array<Maybe<Unit>>;
  useMarketAggregationSource: Scalars['Boolean']['output'];
  useRPC: Scalars['Boolean']['output'];
};

/** MonthEnum defines all the months of a year */
export enum MonthEnum {
  April = 'APRIL',
  August = 'AUGUST',
  December = 'DECEMBER',
  February = 'FEBRUARY',
  January = 'JANUARY',
  July = 'JULY',
  June = 'JUNE',
  March = 'MARCH',
  May = 'MAY',
  November = 'NOVEMBER',
  October = 'OCTOBER',
  September = 'SEPTEMBER'
}

/** MonthOn */
export type MonthOn = {
  __typename?: 'MonthOn';
  on: MonthOnWeekdayEnum;
  weekday: WeekdayEnum;
};

/** MonthOnInput */
export type MonthOnInput = {
  on: MonthOnWeekdayEnum;
  weekday: WeekdayEnum;
};

/** MonthOnWeekdayEnum */
export enum MonthOnWeekdayEnum {
  First = 'FIRST',
  Fourth = 'FOURTH',
  Last = 'LAST',
  Second = 'SECOND',
  Third = 'THIRD'
}

/** MonthlySchedule */
export type MonthlySchedule = {
  __typename?: 'MonthlySchedule';
  byDayOfMonth: Scalars['Boolean']['output'];
  /** day of the month to run */
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  /** MonthlyScheduleInput */
  monthOn?: Maybe<MonthOn>;
  /** The specified months to run */
  months: Array<MonthEnum>;
};

/** MonthlyScheduleInput */
export type MonthlyScheduleInput = {
  byDayOfMonth: Scalars['Boolean']['input'];
  /** day of the month to run */
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  /** MonthlyScheduleInput */
  monthOn?: InputMaybe<MonthOnInput>;
  /** The specified months to run */
  months: Array<MonthEnum>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Delete scheduled exports by Id */
  deleteMTReportSchedules: MtDeleteSchedulesResponse;
  /** Deletes the reports with the specified IDs that are owned by the current user. */
  deleteMTReports: Scalars['Int']['output'];
  /** Disables the report schedules with the specified IDs that are owned by the current user. */
  disableMTReportSchedules: MtDisableSchedulesResponse;
  /** Enables the report schedules with the specified IDs that are owned by the current user. */
  enableMTReportSchedules: MtEnableSchedulesResponse;
  /** Run the saved schedule by Id on demand */
  runMTReportSchedule: Scalars['ID']['output'];
  /** Saves the report criteria and the settings/options on the front end */
  saveMTReport?: Maybe<SaveResponse>;
  /** Saves the report schedule and the settings/options */
  saveMTReportSchedule?: Maybe<SaveResponse>;
};


export type MutationDeleteMtReportSchedulesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteMtReportsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDisableMtReportSchedulesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationEnableMtReportSchedulesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRunMtReportScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSaveMtReportArgs = {
  saveCriteria: MtReportSaveCriteriaInput;
};


export type MutationSaveMtReportScheduleArgs = {
  saveSchedule: ReportScheduleSaveInput;
};

/** Custom filter type supporting numeric comparison */
export type NumberCustomFilterCriteriaInput = {
  compareWith: Scalars['Int']['input'];
  comparisonType: NumericComparisonEnum;
  id: Scalars['ID']['input'];
};

/** NumericComparisonEnum is the set of valid options for custom filter numbers. */
export enum NumericComparisonEnum {
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEquals = 'GREATER_THAN_EQUALS',
  LessThan = 'LESS_THAN',
  LessThanEquals = 'LESS_THAN_EQUALS',
  None = 'NONE'
}

export type Period = {
  __typename?: 'Period';
  date?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  qtr?: Maybe<Scalars['Int']['output']>;
  qtrCode?: Maybe<Scalars['String']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
  weekEndDate?: Maybe<Scalars['String']['output']>;
  weekStartDate?: Maybe<Scalars['String']['output']>;
  year: Scalars['Int']['output'];
};

/** PeriodAggregationEnum is the set of aggregation level values for data aggregation on periods */
export enum PeriodAggregationEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type PeriodCriteria = {
  __typename?: 'PeriodCriteria';
  aggregation?: Maybe<PeriodAggregationEnum>;
  calendarType: Scalars['String']['output'];
  periods?: Maybe<Array<Maybe<PeriodRange>>>;
  quarterFormat?: Maybe<QuarterFormatEnum>;
};

export type PeriodCriteriaInput = {
  aggregation?: InputMaybe<PeriodAggregationEnum>;
  calendarType: Scalars['String']['input'];
  periods?: InputMaybe<Array<InputMaybe<PeriodRangeInput>>>;
  quarterFormat?: InputMaybe<QuarterFormatEnum>;
};

export type PeriodRange = {
  __typename?: 'PeriodRange';
  endDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type PeriodRangeInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type PlanType = {
  __typename?: 'PlanType';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PlanTypeCollection = {
  __typename?: 'PlanTypeCollection';
  allPlanType: PlanType;
  planTypes?: Maybe<Array<Maybe<PlanType>>>;
};

export type Product = {
  __typename?: 'Product';
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ProductHierarchy = {
  __typename?: 'ProductHierarchy';
  hierarchyID: Scalars['ID']['output'];
  hierarchyName: Scalars['String']['output'];
  levels: Array<ProductHierarchyLevel>;
};

export type ProductHierarchy2 = {
  __typename?: 'ProductHierarchy2';
  hierarchyID: Scalars['ID']['output'];
  hierarchyName: Scalars['String']['output'];
  levelTypes: Array<ProductHierarchyLevelType>;
  nodes: ProductHierarchyLevelNodes;
};

export type ProductHierarchyChildren = ProductHierarchyLevelNodes | ProductHierarchyProducts;

export type ProductHierarchyLevel = {
  __typename?: 'ProductHierarchyLevel';
  level: Scalars['Int']['output'];
  levelName: Scalars['String']['output'];
  products: Array<Product>;
};

export type ProductHierarchyLevelNode = {
  __typename?: 'ProductHierarchyLevelNode';
  children: ProductHierarchyChildren;
  levelName: Scalars['String']['output'];
};

export type ProductHierarchyLevelNodes = {
  __typename?: 'ProductHierarchyLevelNodes';
  /** levelType: ProductHierarchyLevelType */
  nodes: Array<ProductHierarchyLevelNode>;
};

export type ProductHierarchyLevelType = {
  __typename?: 'ProductHierarchyLevelType';
  ID: Scalars['ID']['output'];
  Level: Scalars['Int']['output'];
  Name: Scalars['String']['output'];
};

export type ProductHierarchyProducts = {
  __typename?: 'ProductHierarchyProducts';
  products?: Maybe<Array<Maybe<Product>>>;
};

export type ProductHierarchyWithLevelType = {
  __typename?: 'ProductHierarchyWithLevelType';
  hierarchyID: Scalars['ID']['output'];
  hierarchyName: Scalars['String']['output'];
  levelTypes: Array<ProductHierarchyLevelType>;
};

/** QuarterFormatEnum is the set of valid options for quarter format, i.e. Quarter Number and Quarter Code. */
export enum QuarterFormatEnum {
  Code = 'CODE',
  Number = 'NUMBER'
}

export type Query = {
  __typename?: 'Query';
  _service: _Service;
  /** Finds a list of countries */
  findAllMTCountries: Array<Maybe<Country>>;
  /** Finds a list of creatives */
  findAllMTCreatives: Array<Maybe<Creative>>;
  /** Finds a list of currencies */
  findAllMTCurrencies: Array<Maybe<Currency>>;
  /** Finds a list of all currency sources */
  findAllMTCurrencySources: Array<Maybe<CurrencySource>>;
  /** Finds a list of custom (non-standard) calendar entries */
  findAllMTCustomCalendars: Array<Maybe<CalendarEntry>>;
  /** Finds a list of metadata for Custom Creative */
  findAllMTCustomCreatives: Array<Maybe<CustomMetadata>>;
  /** Finds a list of all custom dimenions */
  findAllMTCustomDimensions: Array<Maybe<CustomDimension>>;
  /** Finds a list of all custom filters */
  findAllMTCustomFilters: Array<Maybe<CustomFilter>>;
  /** Finds a list of metadata for Custom Flight Property */
  findAllMTCustomFlightProperties: Array<Maybe<CustomMetadata>>;
  /** Finds a list of metadata for Custom Funding Source */
  findAllMTCustomFundingSources: Array<Maybe<CustomMetadata>>;
  /** Finds a list of metadata for Custom Market */
  findAllMTCustomMarkets: Array<Maybe<CustomMetadata>>;
  /** Finds a list of metadata for Custom Flight Measure */
  findAllMTCustomMeasures: Array<Maybe<Measure>>;
  /** Finds a list of metadata for Custom Plan */
  findAllMTCustomPlans: Array<Maybe<CustomMetadata>>;
  /** Returns a list of data snapshots that are not expired, not marked as deleted and completed */
  findAllMTDataSnapshots: Array<Maybe<Snapshot>>;
  /** Finds a list of demos */
  findAllMTDemos: Array<Maybe<Demo>>;
  /** Finds a list of funding sources */
  findAllMTFundingSources: Array<Maybe<FundingSource>>;
  /** Finds a list of locations */
  findAllMTLocations: Array<Maybe<Location>>;
  /** Finds a list of markets */
  findAllMTMarkets: Array<Maybe<Market>>;
  /** Finds a list of mediaTypes */
  findAllMTMediaTypes: Array<Maybe<MediaType>>;
  /** Finds a list of plan types */
  findAllMTPlanTypes: Array<Maybe<PlanType>>;
  /** Finds plan type list and the special play type item representing ALL */
  findAllMTPlanTypesWithItemAll?: Maybe<PlanTypeCollection>;
  /** Finds a list of products in hierarchy structure using union type on the levels and products */
  findAllMTProductHierarchies: Array<Maybe<ProductHierarchy2>>;
  /** Finds a list of products. Deprecated. Use findAllMTProductHierarchies instead */
  findAllMTProducts: Array<Maybe<ProductHierarchy>>;
  /** Finds all report schedules for a user */
  findAllMTReportSchedules: Array<Maybe<MtReportScheduleSummary>>;
  /** Finds a list of resource sets */
  findAllMTResourceSets: Array<Maybe<ResourceSet>>;
  /** Finds a list of source types */
  findAllMTSourceTypes: Array<Maybe<SourceType>>;
  /** Finds a list of standard calendar entries */
  findAllMTStandardCalendars: Array<Maybe<CalendarEntry>>;
  /** Finds all standard groupings */
  findAllMTStandardGroupings: Array<Maybe<DimensionGrouping>>;
  /** Finds all standard measures */
  findAllMTStandardMeasures: Array<Maybe<Measure>>;
  /** Finds a list of subtypes */
  findAllMTSubtypes: Array<Maybe<Subtype>>;
  /** Finds a list of units */
  findAllMTUnits: Array<Maybe<Unit>>;
  /** Finds all reports for a user */
  findAllMTUserReports: Array<Maybe<MtUserReport>>;
  /** Finds a list of countries by resource set id */
  findMTCountriesByResourceSetIDs: Array<Maybe<Country>>;
  /** Finds a list of demos by resource set id */
  findMTDemosByResourceSetIDs: Array<Maybe<Demo>>;
  /** Finds a list of media types by resource set id */
  findMTMediaTypesByResourceSetIDs: Array<Maybe<MediaType>>;
  /** Finds the report criteria and settings for a given report ID */
  findMTReportParamsByID: MtReportParams;
  /** Finds the full report schedule data for a given ID. */
  findMTReportScheduleByID: MtReportSchedule;
  /** Query view data with static dimension fields in response */
  getMTReporter?: Maybe<MtReporterDataResponse>;
  /**
   * Checks if the given report is referenced in other user's schedule.The caller must be the report owner.
   * May return USER_INPUT_ERROR if the report id is not found for the user and the group associated to the session request
   */
  isReportReferencedInOthersSchedule: Scalars['Boolean']['output'];
  /** Validates the given schedule detail with the generated cron expression for execution atleast once for a given start and end date/time. */
  isScheduleDetailValid: Scalars['Boolean']['output'];
  /**
   * For a given report ID, get the criteria and settings and the results of
   * running the data query.
   */
  runMTReportByID?: Maybe<MtReportDataWithParams>;
};


export type QueryFindMtCountriesByResourceSetIDsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryFindMtDemosByResourceSetIDsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryFindMtMediaTypesByResourceSetIDsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryFindMtReportParamsByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFindMtReportScheduleByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMtReporterArgs = {
  criteria: MtReporterCriteriaInput;
};


export type QueryIsReportReferencedInOthersScheduleArgs = {
  reportID: Scalars['ID']['input'];
};


export type QueryIsScheduleDetailValidArgs = {
  scheduleDetail: ScheduleInput;
};


export type QueryRunMtReportByIdArgs = {
  id: Scalars['ID']['input'];
};

/** ReportDelivery defines detail information needed to deliver a report */
export type ReportDelivery = {
  __typename?: 'ReportDelivery';
  email?: Maybe<EmailDelivery>;
  emailsUponCompletion?: Maybe<Array<Scalars['String']['output']>>;
  fileName: Scalars['String']['output'];
  ftp?: Maybe<FtpDelivery>;
  includeDateTimeInFilename: Scalars['Boolean']['output'];
  method: ReportDeliveryMethodEnum;
};

/** ReportDeliveryInput defines detail information needed to deliver a report */
export type ReportDeliveryInput = {
  email?: InputMaybe<EmailDeliveryInput>;
  emailsUponCompletion?: InputMaybe<Array<Scalars['String']['input']>>;
  fileName: Scalars['String']['input'];
  ftp?: InputMaybe<FtpDeliveryInput>;
  includeDateTimeInFilename: Scalars['Boolean']['input'];
  method: ReportDeliveryMethodEnum;
};

/** ReportDeliveryMethodEnum is the set of delivery method supported in the export. They are FTP and EMAIL */
export enum ReportDeliveryMethodEnum {
  Email = 'EMAIL',
  Ftp = 'FTP'
}

/** ReportExportFormatEnum is the set of file format supported in the report exporting */
export enum ReportExportFormatEnum {
  ColonDelimited = 'COLON_DELIMITED',
  CommaDelimited = 'COMMA_DELIMITED',
  Excel = 'Excel',
  SemicolonDelimited = 'SEMICOLON_DELIMITED',
  TabDelimited = 'TAB_DELIMITED',
  VerticalbarDelimited = 'VERTICALBAR_DELIMITED'
}

/** ReportFormat */
export type ReportFormat = {
  __typename?: 'ReportFormat';
  format: ReportExportFormatEnum;
  includeChecksum: Scalars['Boolean']['output'];
  zip: Scalars['Boolean']['output'];
};

/** ReportFormatInput defines report format information */
export type ReportFormatInput = {
  format: ReportExportFormatEnum;
  includeChecksum: Scalars['Boolean']['input'];
  zip: Scalars['Boolean']['input'];
};

/** ReportScheduleSaveInput */
export type ReportScheduleSaveInput = {
  delivery: ReportDeliveryInput;
  description?: InputMaybe<Scalars['String']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  reportFormat: ReportFormatInput;
  reportId: Scalars['ID']['input'];
  scheduleDetail: ScheduleInput;
};

/** ReportScheduleSummary */
export type ReportScheduleSummary = {
  __typename?: 'ReportScheduleSummary';
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expireDateTime: Scalars['Time']['output'];
  fileFormat: ReportExportFormatEnum;
  folderId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  recurrencePattern: Scalars['String']['output'];
  source: Scalars['String']['output'];
  startDateTime: Scalars['Time']['output'];
  timezone: Scalars['String']['output'];
};

export type ResourceSet = {
  __typename?: 'ResourceSet';
  code?: Maybe<Scalars['String']['output']>;
  countries: Array<Country>;
  demos: Array<Demo>;
  id: Scalars['ID']['output'];
  mediaTypes: Array<MediaType>;
  name: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  region2?: Maybe<Scalars['String']['output']>;
};

/** SFTPConfig defines information needed to deliver a report by SFTP */
export type SftpConfig = {
  __typename?: 'SFTPConfig';
  host: Scalars['String']['output'];
  keyName?: Maybe<Scalars['String']['output']>;
  logonType: SftpLogonTypeEnum;
  password?: Maybe<Scalars['String']['output']>;
  port: Scalars['Int']['output'];
  user: Scalars['String']['output'];
};

/** SFTPConfigInput defines information needed to deliver a report by SFTP */
export type SftpConfigInput = {
  host: Scalars['String']['input'];
  keyName?: InputMaybe<Scalars['String']['input']>;
  logonType: SftpLogonTypeEnum;
  password?: InputMaybe<Scalars['String']['input']>;
  port: Scalars['Int']['input'];
  user: Scalars['String']['input'];
};

/** SFTPLogonTypeEnum is the set of logon type supported in SFTP */
export enum SftpLogonTypeEnum {
  Key = 'KEY',
  Password = 'PASSWORD'
}

/** Response type carrying the saved name in case it is different from the one sent along with the id. */
export type SaveResponse = {
  __typename?: 'SaveResponse';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Schedule */
export type Schedule = {
  __typename?: 'Schedule';
  dailySchedule?: Maybe<DailySchedule>;
  expireDateTime: Scalars['Time']['output'];
  interval: ScheduleIntervalEnum;
  monthlySchedule?: Maybe<MonthlySchedule>;
  startDateTime: Scalars['Time']['output'];
  timezone: Scalars['String']['output'];
  weeklySchedule?: Maybe<WeeklySchedule>;
};

/** ScheduleInput */
export type ScheduleInput = {
  dailySchedule?: InputMaybe<DailyScheduleInput>;
  expireDateTime: Scalars['Time']['input'];
  interval: ScheduleIntervalEnum;
  monthlySchedule?: InputMaybe<MonthlyScheduleInput>;
  startDateTime: Scalars['Time']['input'];
  timezone: Scalars['String']['input'];
  weeklySchedule?: InputMaybe<WeeklyScheduleInput>;
};

/** ScheduleIntervalEnum defines the intervals for running a schedule */
export enum ScheduleIntervalEnum {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum ServerErrorCode {
  BadUserInput = 'BAD_USER_INPUT',
  Forbidden = 'FORBIDDEN',
  InternalSystemError = 'INTERNAL_SYSTEM_ERROR',
  ReportNameExists = 'REPORT_NAME_EXISTS',
  ReportNotFound = 'REPORT_NOT_FOUND',
  ScheduleNameExists = 'SCHEDULE_NAME_EXISTS',
  ScheduleNotFound = 'SCHEDULE_NOT_FOUND',
  Unauthenticated = 'UNAUTHENTICATED'
}

export type Snapshot = {
  __typename?: 'Snapshot';
  createdAt: Scalars['Time']['output'];
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SourceType = {
  __typename?: 'SourceType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type StandardFilterCriteria = {
  __typename?: 'StandardFilterCriteria';
  countries?: Maybe<Array<Scalars['ID']['output']>>;
  demos?: Maybe<Array<Scalars['ID']['output']>>;
  fundingSources?: Maybe<Array<Scalars['ID']['output']>>;
  locations?: Maybe<Array<Scalars['ID']['output']>>;
  markets?: Maybe<Array<Scalars['ID']['output']>>;
  mediaTypes?: Maybe<Array<Scalars['ID']['output']>>;
  planTypes?: Maybe<Array<Scalars['ID']['output']>>;
  products?: Maybe<Array<Scalars['ID']['output']>>;
  subtypes?: Maybe<Array<Scalars['ID']['output']>>;
  units?: Maybe<Array<Scalars['ID']['output']>>;
};

export type StandardFilterCriteriaInput = {
  countries?: InputMaybe<Array<Scalars['ID']['input']>>;
  demos?: InputMaybe<Array<Scalars['ID']['input']>>;
  fundingSources?: InputMaybe<Array<Scalars['ID']['input']>>;
  locations?: InputMaybe<Array<Scalars['ID']['input']>>;
  markets?: InputMaybe<Array<Scalars['ID']['input']>>;
  mediaTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  planTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  products?: InputMaybe<Array<Scalars['ID']['input']>>;
  subtypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  units?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** StringComparisonEnum is the set of valid options for custom filter strings. */
export enum StringComparisonEnum {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  None = 'NONE',
  StartsWith = 'STARTS_WITH'
}

/** Custom filter type supporting string comparison */
export type StringCustomFilterCriteria = {
  __typename?: 'StringCustomFilterCriteria';
  compareWith: Scalars['String']['output'];
  comparisonType: StringComparisonEnum;
  id: Scalars['ID']['output'];
};

/** Custom filter type supporting string comparison */
export type StringCustomFilterCriteriaInput = {
  compareWith: Scalars['String']['input'];
  comparisonType: StringComparisonEnum;
  id: Scalars['ID']['input'];
};

export type Subtype = {
  __typename?: 'Subtype';
  category?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publisher?: Maybe<Scalars['String']['output']>;
};

export type Unit = {
  __typename?: 'Unit';
  equivRatio?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  inactive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** UserReport is the type returned by the list user reports API. */
export type UserReport = {
  __typename?: 'UserReport';
  associatedSchedules: Array<Maybe<AssociatedSchedule>>;
  created: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiresOn: Scalars['Int']['output'];
  folderId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastModified: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nationId: Scalars['Int']['output'];
  productId: Scalars['Int']['output'];
  shared: Scalars['Boolean']['output'];
  typeId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

/** WeekdayEnum defines all the weekdays */
export enum WeekdayEnum {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** WeeklySchedule */
export type WeeklySchedule = {
  __typename?: 'WeeklySchedule';
  weekOn: Array<WeekdayEnum>;
};

/** WeeklyScheduleInput */
export type WeeklyScheduleInput = {
  weekOn: Array<WeekdayEnum>;
};

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};
